<template>
  <DateRangePicker v-model="dateRange" :placeholder="t('common.datepicker.select_date')" />
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { format } from 'date-fns';
import { useI18n } from 'vue-i18n';
import { DateRangePicker } from '@/components/ui/date-picker';

const { t } = useI18n();

const emit = defineEmits(['selectDate']);

const props = defineProps<{
  initialDate?: [Date, Date];
  clearSelectsEmptyRange?: boolean;
}>();

const dateRange = ref<{ from: Date | undefined; to: Date | undefined }>(
  props.initialDate
    ? { from: props.initialDate[0], to: props.initialDate[1] }
    : { from: undefined, to: undefined }
);

watch(
  dateRange,
  value => {
    if (props.clearSelectsEmptyRange && (!value?.from || !value?.to)) {
      emit('selectDate', { startDate: '', endDate: '' });
      return;
    }
    const from = value?.from ?? new Date();
    const to = value?.to ?? new Date();
    emit('selectDate', {
      startDate: format(from, 'yyyy-MM-dd'),
      endDate: format(to, 'yyyy-MM-dd'),
    });
  },
  { deep: true }
);
</script>
